<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Antecipar Destrancamento de Matrícula</h6>
        <i class="bi bi-x-circle close-icon" @click="fecharModal"></i>
      </div>

      <!-- Conteúdo do Modal -->
      <div class="modal-content">
        <!-- Seção: Contrato do Aluno -->
        <div class="mb-3">
          <h5 class="section-title">Contrato do Aluno</h5>
          <div class="row">
            <div class="col-md-5">
              <label>Aluno</label>
              <input type="text" class="form-control" :value="matricula.aluno_nome" disabled />
            </div>
            <div class="col-md-3">
              <label>Vigência</label>
              <input type="text" class="form-control" :value="vigenciaTexto" disabled />
            </div>
            <div class="col-md-2">
              <label>Nº do Contrato</label>
              <input type="text" class="form-control" :value="matricula.numero_contrato" disabled />
            </div>
            <div class="col-md-2">
              <label>Nº da Matrícula</label>
              <input type="text" class="form-control" :value="matricula.id" disabled />
            </div>
          </div>
        </div>

        <!-- Seção: Período de Trancamento (read-only) -->
        <div class="mb-3">
          <h5 class="section-title">Período de Trancamento</h5>
          <div class="row">
            <div class="col-md-2">
              <label>Início</label>
              <input type="date" class="form-control" :value="periodoTrancamentoData.inicio" disabled />
            </div>
            <div class="col-md-2">
              <label>Fim</label>
              <input type="date" class="form-control" :value="periodoTrancamentoData.fim" disabled />
            </div>
            <div class="col-md-8">
              <label>Observações</label>
              <textarea class="form-control" :value="periodoTrancamentoData.observacoes" disabled></textarea>
            </div>
          </div>
        </div>

        <!-- Seção: Dados de Destrancamento -->
        <div class="mb-3">
          <h5 class="section-title">Dados de Destrancamento</h5>
          <div class="row">
            <div class="col-md-3">
              <label>Data <span class="required">*</span></label>
              <input
                type="date"
                class="form-control"
                v-model="form.data_destrancamento"
                required
              />
            </div>
            <div class="col-md-9">
              <label>Observações <span class="required">*</span></label>
              <textarea
                class="form-control"
                v-model="form.observacoes"
                rows="1"
                required
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Botão Salvar -->
        <div class="row mt-3">
          <div class="col text-end">
            <button
              :class="['btn', isSaving ? 'btn-success' : 'btn-primary']"
              :disabled="!formIsValid || isSaving"
              @click="salvar"
            >
              {{ isSaving ? 'Salvando' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "@/services/axios";
import globalUtils from "@/utils/globalUtils.js";

export default {
  name: "DestrancarMatricula",

  props: {
    mostrar: { type: Boolean, default: false },
    matricula: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      isSaving: false,
      form: {
        data_destrancamento: "",
        observacoes: "",
      },
      periodoTrancamentoData: {
        inicio: "",
        fim: "",
        observacoes: "",
      },
      destrancamentoExistente: false,
      destrancamentoId: null,
      existingDestrancamentoData: {
        data_destrancamento: "",
        observacoes: "",
      },
    };
  },

  computed: {
    vigenciaTexto() {
      return `${globalUtils.formatarData(this.matricula.inicio_vigencia)} a ${globalUtils.formatarData(this.matricula.termino_vigencia)}`;
    },
    formIsValid() {
      return !!(this.form.data_destrancamento && this.form.observacoes);
    },
  },

  watch: {
    mostrar(val) {
      if (!val) return;

      this.resetForm();

      // popula os campos de trancamento
      if (this.matricula.inicio_trancamento && this.matricula.termino_trancamento) {
        this.periodoTrancamentoData.inicio = this.matricula.inicio_trancamento.split("T")[0];
        this.periodoTrancamentoData.fim    = this.matricula.termino_trancamento.split("T")[0];
        this.periodoTrancamentoData.observacoes = this.matricula.observacoes_trancamento || "";
      }
      // verifica destrancamento existente
      if (this.matricula.data_destrancamento) {
        const dataDest = this.matricula.data_destrancamento.split("T")[0];
        this.form.data_destrancamento = dataDest;
        this.form.observacoes = this.matricula.observacoes_destrancamento || "";
        this.existingDestrancamentoData = {
          data_destrancamento: dataDest,
          observacoes: this.matricula.observacoes_destrancamento || "",
        };
        this.destrancamentoExistente = true;
        this.destrancamentoId = this.matricula.destrancamento_id || null;
      } else {
        this.destrancamentoExistente = false;
        this.destrancamentoId = null;
        this.existingDestrancamentoData = { data_destrancamento: "", observacoes: "" };
      }
    },
  },

  methods: {
    fecharModal() {
      this.isSaving = false;
      this.$emit("fechar");
    },

    resetForm() {
      this.form = {
        data_destrancamento: "",
        observacoes: "",
      };
    },


    calcularDias(inicioStr, fimStr) {
      if (!inicioStr || !fimStr) return 0;
      const [yi, mi, di] = inicioStr.split("-").map(Number);
      const [yf, mf, df] = fimStr.split("-").map(Number);
      const dataI = new Date(0);
      dataI.setUTCFullYear(yi, mi - 1, di);
      const dataF = new Date(0);
      dataF.setUTCFullYear(yf, mf - 1, df);
      const diffMs = dataF.getTime() - dataI.getTime();
      return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    },

    subtrairDias(dateStr, dias) {
      if (!dateStr) return "";
      const [y, m, d] = dateStr.split("-").map(Number);
      const dt = new Date(0);
      dt.setUTCFullYear(y, m - 1, d);
      dt.setUTCDate(dt.getUTCDate() - dias);
      return dt.toISOString().slice(0, 10);
    },

    async salvar() {
      // evita cliques múltiplos
      if (this.isSaving) return;

      // Extrai apenas a parte YYYY-MM-DD ou null
      const dataDest = this.form.data_destrancamento
        ? String(this.form.data_destrancamento).split("T")[0]
        : null;
      const fimTranc = this.periodoTrancamentoData.fim
        ? String(this.periodoTrancamentoData.fim).split("T")[0]
        : null;

      // Validação “nenhuma alteração”
      if (
        this.destrancamentoExistente &&
        dataDest === this.existingDestrancamentoData.data_destrancamento &&
        this.form.observacoes === this.existingDestrancamentoData.observacoes
      ) {
        alert("Nenhuma alteração detectada. Altere os dados para atualizar o destrancamento.");
        return;
      }

      this.isSaving = true;

      // Calcula quantos dias reduzir
      const diasReduzidos = (dataDest && fimTranc)
        ? this.calcularDias(dataDest, fimTranc)
        : 0;

      // Monta novo término de vigência ou null
      const terminoStr = this.matricula.termino_vigencia
        ? String(this.matricula.termino_vigencia).split("T")[0]
        : null;
      const novoTerminoVigencia = terminoStr
        ? this.subtrairDias(terminoStr, diasReduzidos)
        : null;

      // Nome de usuário
      const userName = this.$globalState?.userName || "Fausto Raupp";

      // Prepara payload, trocando strings vazias por null
      const payload = {
        matricula_id: this.matricula.id,
        aluno: this.matricula.aluno_nome,
        vigencia: this.vigenciaTexto,
        numero_contrato: this.matricula.numero_contrato,
        matricula_numero: this.matricula.id,
        periodo_trancamento: {
          inicio: this.periodoTrancamentoData.inicio || null,
          fim: fimTranc,
          dias: diasReduzidos,
          observacoes: this.form.observacoes || null,
        },
        data_destrancamento: dataDest,
        novo_termino_vigencia: novoTerminoVigencia,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        trancamentoExistente: this.destrancamentoExistente,
        destrancamento_id: this.destrancamentoId,
        trancamento_id: this.matricula.trancamento_id,
        nome_usuario: userName,
      };

      try {
        const response = await axios.post(
          "/operacional/matriculas-destrancamentos",
          payload
        );
        this.$emit("salvou", response.data);
        this.fecharModal();
      } catch (error) {
        console.error("Erro ao salvar destrancamento:", error);
        this.$alert && this.$alert(error.response?.data?.error || error.response?.data?.detail || "Não foi possível salvar o destrancamento.", "Erro");
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 60%;
  border-radius: 4px;
  overflow: hidden;
}
.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-content {
  padding: 15px;
}
.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}
.required {
  color: red;
}
</style>
